export const RESTRIKTION_TYPE = {
  KEINE_ABREISE_HART: 'keine-abreise-hart',
  KEINE_ABREISE: 'keine-abreise',
  KEINE_REISEN: 'keine-reisen',
};

// Konfiguration je Typ
// bgColor und borderColor werden für die Kachel-Fläche verwendet
// textColor färbt Icon und Text
// priority steuert, welcher Typ bei mehreren Restriktionen am selben Tag angezeigt wird
// höhere Zahl gewinnt: KEINE_ABREISE_HART (rot) > KEINE_ABREISE (gelb) > KEINE_REISEN (grau)
export const RESTRIKTION_TYPE_CONFIG = {
  [RESTRIKTION_TYPE.KEINE_ABREISE_HART]: {
    label: 'KEINE ABREISE',
    modalLabel: 'EINMALIG',
    icon: 'Ban',
    textColor: '#C10007',
    bgColor: '#F64E6026',
    borderColor: '#F64E60',
    priority: 3,
  },
  [RESTRIKTION_TYPE.KEINE_ABREISE]: {
    label: 'KEINE ABREISE',
    modalLabel: 'WIEDERKEHREND',
    icon: 'Repeat',
    textColor: '#D97706',
    bgColor: '#FFA80026',
    borderColor: '#FFA800',
    priority: 2,
  },
  [RESTRIKTION_TYPE.KEINE_REISEN]: {
    label: 'KEINE REISEN',
    modalLabel: 'GESPERRTE SAISON',
    icon: 'CalendarOff',
    textColor: '#4B5563',
    bgColor: '#B5B5C326',
    borderColor: '#B5B5C3',
    priority: 1,
  },
};

export function getRestriktionTypeConfig(type) {
  return RESTRIKTION_TYPE_CONFIG[type] || RESTRIKTION_TYPE_CONFIG[RESTRIKTION_TYPE.KEINE_REISEN];
}

// GesperrteSaison ist grau, einmalige GesperrteAbreise (Single) rot, wiederkehrende gelb
export function mapRestriktionstyp(restriktionstyp, wiederholungstyp) {
  if (restriktionstyp === 'GesperrteSaison') {
    return RESTRIKTION_TYPE.KEINE_REISEN;
  }
  if (restriktionstyp === 'GesperrteAbreise') {
    return wiederholungstyp === 'Single'
      ? RESTRIKTION_TYPE.KEINE_ABREISE_HART
      : RESTRIKTION_TYPE.KEINE_ABREISE;
  }
  return RESTRIKTION_TYPE.KEINE_REISEN;
}

// Anzeige-Labels
export const RESTRIKTIONSGRUND_LABEL = {
  SaisonaleVerfuegbarkeit: 'Saisonale Verfügbarkeit',
  SaisonalesEreignisFeiertag: 'Saisonales Ereignis / Feiertag',
  OperativeEinschraenkungen: 'Operative Einschränkungen',
  FehlendeFlugverfuegbarkeit: 'Fehlende Flugverfügbarkeit',
  InternBlockiert: 'Intern blockiert',
  Sonstiges: 'Sonstiges',
};

export function getRestriktionsgrundLabel(grund) {
  return RESTRIKTIONSGRUND_LABEL[grund] || grund;
}

export const RESTRIKTIONSGRUND_OPTIONS = Object.entries(RESTRIKTIONSGRUND_LABEL).map(([value, text]) => ({
  value,
  text,
}));

export const RESTRIKTIONSTYP_OPTIONS = [
  { value: 'GesperrteAbreise', text: 'Gesperrter Abreisetag' },
  { value: 'GesperrteSaison', text: 'Gesperrte Saison' },
];

export const SERIE_BIS_UNBEFRISTET = '9999-12-31';

export const TAB_ZU_WIEDERHOLUNGSTYP = {
  einmalig: 'Single',
  woechentlich: 'Weekly',
  monatlich: 'Monthly',
  jaehrlich: 'Monthly',
};

export function getWiederholungTab(entry) {
  if (entry.wiederholungstyp === 'Weekly') {
    return 'woechentlich';
  }
  if (entry.wiederholungstyp === 'Monthly') {
    return entry.turnus === 12 && !(entry.wochentage || []).length ? 'jaehrlich' : 'monatlich';
  }
  return 'einmalig';
}

export const WIEDERHOLUNG_LABEL = {
  Weekly: 'Wöchentlich',
  Monthly: 'Monatlich',
};

export function getWiederholungLabel(wiederholungstyp) {
  return WIEDERHOLUNG_LABEL[wiederholungstyp] || null;
}

export function getRestriktionBezeichnung(entry) {
  if (entry.type === RESTRIKTION_TYPE.KEINE_REISEN) {
    return 'gesperrte Saison';
  }
  return entry.type === RESTRIKTION_TYPE.KEINE_ABREISE_HART
    ? 'einmalige Sperrzeit'
    : 'wiederkehrende Sperrzeit';
}

// Restriktionen absteigend nach Priorität sortiert
export function sortRestriktionenByPriority(entries = []) {
  return [...entries].sort(
    (a, b) => getRestriktionTypeConfig(b.type).priority - getRestriktionTypeConfig(a.type).priority
  );
}
